/**
 * 存储必要参数
 */

// import Session from 'js-cookie'
const Session = window.sessionStorage

export const TOKEN_KEY = '_merchant_token'
export const OPENID_KEY = '_merchant_oppenid'
export const SHOP_KEY = '_merchant_shop'
export const STORE_KEY = '_merchant_store'
export const STAFF_KEY = '_merchant_staff'
export const TIME_KEY = '_merchant_time'
export const START_TIME_KEY = '_merchant_start_time'
export const END_TIME_KEY = '_merchant_end_time'
export const IS_TIME = '_merchant_is_time'
export const JSON_API = '_merchant_json_api'

export const MC_RC_JSON = '_merchant_received _json'
export const MC_RD_JSON = '_merchant_refund _json'
export const MC_CHARGE_JSON = 'charge _json'

export const TENANT_ID = '_merchant_tenant_id'
export const TENANT_LOGO = '_merchant_tenant_logo'
export const TENANT_NAME = '_merchant_tenant_name'

export const setToken = token => {
  Session.setItem(TOKEN_KEY, token)
}

export const getToken = () => {
  return Session.getItem(TOKEN_KEY)
}

export const setOpenid = openid => {
  Session.setItem(OPENID_KEY, openid)
}

export const getOpenid = () => {
  return Session.getItem(OPENID_KEY)
}

export const setTenantId = teandId => {
  Session.setItem(TENANT_ID, teandId)
}

export const getTenantId = () => {
  return Session.getItem(TENANT_ID)
}

export const setTenantLogo = teandLogo => {
  Session.setItem(TENANT_LOGO, teandLogo)
}

export const getTenantLogo = () => {
  return Session.getItem(TENANT_LOGO)
}

export const setTenantName = teandName => {
  Session.setItem(TENANT_NAME, teandName)
}

export const getTenantName = () => {
  return Session.getItem(TENANT_NAME)
}

export const setShop = shop => {
  Session.setItem(SHOP_KEY, shop)
}

export const getShop = () => {
  Session.getItem(SHOP_KEY)
}

export const setApiJson = str => {
  Session.setItem(JSON_API, str)
}

export const getApiJson = () => {
  return Session.getItem(JSON_API)
}

export const setStore = store => {
  Session.setItem(STORE_KEY, store)
}

export const getStore = () => {
  return Session.getItem(STORE_KEY)
}

export const setStaff = staff => {
  Session.setItem(STAFF_KEY, staff)
}

export const getStaff = () => {
  return Session.getItem(STAFF_KEY)
}

export const setTime = time => {
  Session.setItem(TIME_KEY, time)
}

export const getTime = () => {
  return Session.getItem(TIME_KEY)
}

export const setStartTime = time => {
  Session.setItem(START_TIME_KEY, time)
}

export const getStartTime = () => {
  return Session.getItem(START_TIME_KEY)
}

export const setEndTime = time => {
  Session.setItem(END_TIME_KEY, time)
}

export const getEndTime = () => {
  return Session.getItem(END_TIME_KEY)
}

export const setIsTime = state => {
  Session.setItem(IS_TIME, state)
}

export const getIsTime = () => {
  return Session.getItem(IS_TIME)
}

/**
 *暂存查询数据
 * MC_RC_JSON => 商户实收
 * MC_RD_JSON => 商户推广
 * @params data => json数据流
 * */

export const setMcRcJson = data => {
  Session.setItem(MC_RC_JSON, data)
}

export const getMcRcJson = () => {
  return Session.getItem(MC_RC_JSON)
}

export const setMcRdJson = data => {
  Session.setItem(MC_RD_JSON, data)
}

export const getMcRdJson = () => {
  return Session.getItem(MC_RD_JSON)
}

export const setMcChargeJson = data => {
  Session.setItem(MC_CHARGE_JSON, data)
}

export const getMcChargeJson = () => {
  return Session.getItem(MC_CHARGE_JSON)
}
